var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-card-text',[_vm._v(" "+_vm._s(_vm.$t( 'Diese Aktivität benötigt keine weiteren Einstellungen. Nutzen Sie Materialien und Content Links, um die Inhalte, die gelesen werden sollen, darzustellen' ))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }